import StringUtils from '@/utils/StringUtils';
import {CaseItemDto, CaseMeddraItemDto} from '@/model/CommonModel';

export default class CommonValidators {
    public static required = (vm: any, messageCode: string = 'message.commonValidator.required') => {
        return (rule: any, value: any, callback: any) => {
            if (!StringUtils.hasValue(value) || (value instanceof String && !StringUtils.hasValue(value.replace(/ /g, '')))
                || (value instanceof Array && value.length === 0)) {
                callback(new Error(vm.$root.$t(messageCode)));
            } else {
                callback();
            }
        };
    }

    public static sponsorRequired = (vm: any, messageCode: string = 'message.commonValidator.required') => {
        return (rule: any, value: any, callback: any) => {
            if (value instanceof Number || value === '' || StringUtils.hasValue(value.toString().replace(/ /g, ''))) {
                callback();
            } else {
                callback(new Error(vm.$root.$t(messageCode)));
            }
        };
    }

    public static emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    public static email = (vm: any, messageCode: string = 'message.commonValidator.invalid') => {
        return (rule: any, value: any, callback: any) => {
            if (!CommonValidators.emailPattern.test(value)) {
                callback(new Error(vm.$root.$t(messageCode)));
            } else {
                callback();
            }
        };
    }
    
    public static caseRequired = (vm: any, messageCode: string = 'message.commonValidator.required') => {
        return (rule: any, item: CaseItemDto, callback: any) => {
            let value = item.value as string;
            if (StringUtils.hasValue(value)) {
                callback();
                return;
            }
            
            value = item.nullFlavor as string;
            if (StringUtils.hasValue(value)) {
                callback();
                return;
            }
            callback(new Error(vm.$root.$t(messageCode)));
        };
    }
    
    public static meddraVersionRequired = (vm: any, messageCode: string = 'message.commonValidator.required') => {
        return (rule: any, item: CaseItemDto, callback: any) => {
            let value = item.value as string;
            if (StringUtils.hasValue(value)) {
                callback();
                return;
            }
            
            value = item.nullFlavor as string;
            if (StringUtils.hasValue(value)) {
                callback();
                return;
            }
            
            callback(new Error(vm.$root.$t(messageCode)));
        };
    }
    
    public static meddraLltRequired = (vm: any, messageCode: string = 'message.commonValidator.required') => {
        return (rule: any, item: CaseItemDto, callback: any) => {
            let value = item.value as string;
            if (StringUtils.hasValue(value)) {
                callback();
                return;
            }
            
            value = item.nullFlavor as string;
            if (StringUtils.hasValue(value)) {
                callback();
                return;
            }
            
            callback(new Error(vm.$root.$t(messageCode)));
        };
    }
}
